// ==============================|| OVERRIDES - POPOVER ||============================== //

export default function Popover(theme) {
    return {
        MuiPopover: {
            styleOverrides: {
                paper: {
                    // boxShadow: theme.customShadows.z1,
                   // background: theme.palette.primary[100]
                }
            }
        }
    };
}
